import { render, staticRenderFns } from "./InitiateTemplate.vue?vue&type=template&id=2ef3559e&scoped=true&"
import script from "./InitiateTemplate.vue?vue&type=script&lang=js&"
export * from "./InitiateTemplate.vue?vue&type=script&lang=js&"
import style0 from "./InitiateTemplate.vue?vue&type=style&index=0&id=2ef3559e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ef3559e",
  null
  
)

export default component.exports